<kilowant-header [isSeller]="true" title="Bulk Import"></kilowant-header>
<div class="mt-50 mb-50 text-center">Please complete the following steps to upload your bulk pricing data</div>
<div class="progress-tabs">
  <span [className]="(step==1)?'current':''">1</span>
  <span [className]="(step==2)?'current':''">2</span>
  <span [className]="(step==3)?'current':''">3</span>
</div>
<div class="form seller">
  <div class="card">
    <div class="left-margin"><span class="step-title">1</span></div>
    <div class="body">
      <p class="mb-0"><b>Please download the .csv template file that you will use to import your pricing data into kilowant</b></p>
      <div class="row mt-4 mb-3">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
          <div class="downloadFile d-flex justify-content-between">
            <p class="mb-0">bulk-import.csv</p>
            <img src="i/downloadBtn.png" class="cursor-pointer" (click)="getTemplateFile('bulk-import.csv')">
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (step==1) {
    <div class="block-buttons justify-content-end">
      <button type="button" (click)="nextStep()">Next</button>
      <button type="button" (click)="fileUpload()">Skip & Upload File</button>
    </div>
  }
  @if (step > 1) {
    <div class="card">
      <div class="left-margin"><span class="step-title">2</span></div>
      <div class="body">
        <p class="mb-0"><b>Please fill in the file with your pricing data using the following tables as a reference</b></p>
        <div class="d-flex mt-20">
          <div class="auto">
            <table mat-table matSort #utilitiesTableSort="matSort" [dataSource]="dataSource" matSortActive="UtilityName" matSortDisableClear
              matSortDirection="asc" class="offer-summmary-table" multiTemplateDataRows>
              <ng-container matColumnDef="UtilityName">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Utility Name</th>
                <td mat-cell *matCellDef="let element" >{{element.UtilityName}}</td>
              </ng-container>
              <ng-container matColumnDef="UtilityID">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Utility ID</th>
                <td mat-cell *matCellDef="let element" >{{element.UtilityID}}</td>
              </ng-container>
              <ng-container matColumnDef="LoadZoneName">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Load Zone Name</th>
                <td mat-cell *matCellDef="let element" >{{element.LoadZoneName}}</td>
              </ng-container>
              <ng-container matColumnDef="LoadZoneID">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Load Zone ID</th>
                <td mat-cell *matCellDef="let element" >{{element.LoadZoneID}}</td>
              </ng-container>
              <ng-container matColumnDef="RateClassName">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Rate Class Name</th>
                <td mat-cell *matCellDef="let element" >{{element.RateClassName}}</td>
              </ng-container>
              <ng-container matColumnDef="RateClassID">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Rate Class ID</th>
                <td mat-cell *matCellDef="let element" >{{element.RateClassID}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <div class="ml-20">
            <table mat-table matSort #contractsTableSort="matSort" [dataSource]="dataSource2" matSortActive="ContractName" matSortDisableClear
              matSortDirection="asc" class="offer-summmary-table" multiTemplateDataRows>
              <ng-container matColumnDef="ContractName">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Sales Agreement</th>
                <td mat-cell *matCellDef="let element" >{{element.name}}</td>
              </ng-container>
              <ng-container matColumnDef="ContractID">
                <th mat-header-cell mat-sort-header *matHeaderCellDef >Sales Agreement ID</th>
                <td mat-cell *matCellDef="let element">{{element.id}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
              <tr mat-row *matRowDef="let element; let row; columns: displayedColumns2;"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
  @if (step==2) {
    <div class="block-buttons justify-content-end">
      <button type="button" (click)="backStep()">Back</button>
      <button type="button" (click)="nextStep()">Next</button>
    </div>
  }
  @if (step == 3) {
    <div class="card">
      <a id="step3"></a>
      <div class="left-margin"><span class="step-title">3</span></div>
      <div class="body">
        <p class="mb-0"><b>Please upload your completed .csv template file to import the data into kilowant</b></p>
        <div class="row mt-4 mb-3">
          <div class="p-0 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="d-flex">
              @if (!uploading) {
                <label class="upload-with-progress" [class]="(errors.includes('fileToUpload'))?'error':''" for="dataFile">
                  @if (fileToUpload!=null) {
                    <span>{{fileToUpload.name}}</span>
                  }
                  <img src="i/attachFile.png" class="cursor-pointer" >
                  <input type="file" name="dataFile" id="dataFile" class="required" value="" placeholder="Data File" (change)="handleFileInput($event)"/>
                </label>
              }
              @if (uploading) {
                <div class="progress-circle" [attr.data-progress]="progress">
                  <div class="circle">
                    <div class="full slice" [attr.style]="'transform: rotate('+180/100*progress+'deg);'">
                      <div class="fill" [attr.style]="'transform: rotate('+180/100*progress+'deg);'"></div>
                    </div>
                    <div class="slice">
                      <div class="fill" [attr.style]="'transform: rotate('+180/100*progress+'deg);'"></div>
                      <div class="fill bar" [attr.style]="'transform: rotate('+360/100*progress+'deg);'"></div>
                    </div>
                  </div>
                  <div class="overlay">{{progress}} %</div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (step == 3) {
    <div class="block-buttons justify-content-end">
      <button type="button" (click)="backStep()">Back</button>
      <button type="button" (click)="sendForm()">Upload</button>
    </div>
  }
</div>